import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HERO_FACTS } from "@/data/content";
import { PlacesCounter } from "@/components/site/PlacesCounter";

const fade = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.2, 0.65, 0.3, 1] } });

const FactsCard = ({ camp }) => (
  <motion.div {...fade(0.8)} data-testid="hero-facts-card" className="rounded-3xl bg-[#070a11]/55 backdrop-blur-2xl border border-white/10 p-6 md:p-7">
    <div className="mb-4 empty:hidden"><PlacesCounter camp={camp} /></div>
    <div className="divide-y divide-white/10">
      {HERO_FACTS.map((f, i) => (
        <div key={f.k} data-testid={`hero-fact-${i}`} className="flex items-center justify-between gap-4 py-3">
          <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-400">{f.k}</p>
          <p className="font-semibold text-[15px] text-right">{f.v}</p>
        </div>
      ))}
    </div>
  </motion.div>
);

export const Hero = ({ camp, onRegister }) => (
  <section id="top" data-testid="hero-section" className="relative px-3 sm:px-4 pt-[88px] pb-3">
    <div className="relative min-h-[calc(100svh-100px)] rounded-[2rem] overflow-hidden grain flex items-end">
      <img src="/images/hero.jpg" alt="Youth players training under floodlights" className="absolute inset-0 w-full h-full object-cover hero-zoom" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#070a11] via-[#070a11]/55 to-[#070a11]/5" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#070a11]/80 via-[#070a11]/20 to-transparent" />
      <div className="absolute -left-40 -bottom-40 w-[620px] h-[620px] rounded-full bg-[#ccff00]/10 blur-[140px]" />

      <div className="relative w-full px-6 sm:px-10 lg:px-14 pt-28 pb-8 md:pb-12 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8 min-w-0">
          <motion.p {...fade(0.2)} className="eyebrow mb-7"><span className="live-dot w-1.5 h-1.5 rounded-full bg-[#ccff00]" />Adelaide · 12–20 December 2026</motion.p>
          <motion.h1 {...fade(0.35)} data-testid="hero-title" className="font-display font-extrabold leading-[0.92] tracking-[-0.045em] text-[1.95rem] sm:text-6xl lg:text-[6.75rem]">
            Elite Performance <span className="accent-text">Lab</span>
          </motion.h1>
          <motion.p {...fade(0.55)} data-testid="hero-tagline" className="mt-6 text-lg sm:text-2xl text-slate-200 font-medium max-w-2xl">
            9 Days. Elite Coaching. Professional Development.
          </motion.p>
          <motion.div {...fade(0.7)} className="mt-9 flex flex-col sm:flex-row gap-3">
            <button onClick={onRegister} className="btn-primary" data-testid="hero-register-button">Secure Your Spot <ArrowRight size={18} /></button>
            <a href="#programme" className="btn-ghost" data-testid="hero-explore-button">Explore the Programme</a>
          </motion.div>
        </div>
        <div className="lg:col-span-4 min-w-0"><FactsCard camp={camp} /></div>
      </div>
    </div>
  </section>
);
